import axios from "axios";
import { API } from "../../utils/api.config";

export async function getSubscriptionPackagesApi() {
  return await API.get(`api/packages`);
}

export async function postSubscriptionPackagesApi(data) {
  return await API.get(`api/payment/sub?${data}`);
}

export async function unsubscribeApi(data) {
  return await API.get(`api/payment/unsub?${data}`);
}
export async function unsubscribeApiSsl(data) {
  return await API.get(`/api/payment/online/${data}/unsub`);
}

export async function postSsl(packageType, productId) {
  // return await API.post(`/api/payment/online/${packageType}/sub?productId=${productId}`);
  return await API.post(`/payment/api/v2/pgw/${packageType}/subscription`, {
    productId: productId,
  });
}

export async function postCouponSubscription(couponCode, productId) {
  return await API.post(`/payment/api/v1/coupon/subscription`, {
    couponCode,
    productId,
  });
}

export async function postOtpConsent(partnerId, txnId, otpCode) {
  try {
    const response = await API.post(
      `/payment/api/v2/pgw/${partnerId}/consent`,
      {
        txnId,
        consentNo: otpCode,
      },
    );
    // console.log("Response data:", response.data);
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      // Handle Axios-specific errors
      if (error.response) {
        // Server responded with a status other than 2xx
        console.error("Error status:", error.response.status);
        console.error("Error data:", error.response.data);
        return {
          success: false,
          status: error.response.status,
          data: error.response.data,
        };
      } else if (error.request) {
        // Request was made but no response received
        console.error("No response received:", error.request);
        return {
          success: false,
          message: "No response received from the server.",
        };
      } else {
        // Other errors during the setup
        console.error("Error message:", error.message);
        return {
          success: false,
          message: error.message,
        };
      }
    } else {
      // Non-Axios errors
      console.error("Unexpected error:", error);
      return {
        success: false,
        message: "An unexpected error occurred.",
      };
    }
  }
}
